import React, { useState } from 'react'
import './searchbox.css'
import searchIcon from '../assets/searchIcon.svg'
import CloseIcon from '@mui/icons-material/Close'

interface SearchBoxProps {
  searchVal: string
  setSearchVal: (val: string) => void
  classes?: string
  parameters?: [] | string
  performAction: () => void
  emptyEnterFallback: () => void
}

const SearchBox = (props: SearchBoxProps): JSX.Element => {
  const [isInputEmpty, setIsInputEmpty] = useState(true)
  const handleKeyEnter = (event: React.KeyboardEvent<HTMLInputElement>): void => {
    if (event.key === 'Enter') {
      if (props.performAction !== undefined && typeof props.performAction === 'function' && props.searchVal !== '') {
        props.performAction()
      } else if (props.searchVal === '') {
        props.emptyEnterFallback()
      }
    }
  }

  const handleClearInput = (): void => {
    props.setSearchVal('') // Clear the input
    setIsInputEmpty(true)
    props.emptyEnterFallback()
  }

  return (
    <div className={`custom-search-box-component ${props.classes !== undefined ? props.classes : ''}`}>
      <div className='custom-search-box'>
        <i className='search-box-icon-img'><img className='search-icon' src={searchIcon} /></i>
        <input className='search-box-input'
               onChange={(e) => {
                 props.setSearchVal(e.target.value)
                 setIsInputEmpty(e.target.value === '')
               }}
               placeholder='Search using Serial Number, Asset Name'
               onKeyDown={handleKeyEnter}
               value={props.searchVal} />
        <span className='search-cross-bar'>{!isInputEmpty && (<CloseIcon onClick={handleClearInput}/>)}</span>
      </div>
    </div>
  )
}

export default SearchBox
